/*
 * File: index.tsx
 * Desc: tab inkbar 组件
 * File Created: 2019-10-28 17:21:30
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useRef, useLayoutEffect } from 'react';
import classNames from 'classnames';

const prefix = 'rac_tab_inkbar';

interface TabInkbarProps {
    className?: string;
    style?: React.CSSProperties;
    offsetLeft: number;
    targetWidth: number;
}

let recorder = 0;

/** tab bar 下划线组件 */
const TabInkbar = (props: TabInkbarProps) => {
    const { offsetLeft, targetWidth } = props;
    const inkRef = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {
        if (inkRef.current) {
            recorder++;
            const offsetWidth = inkRef.current.offsetWidth;
            inkRef.current.style.transform = `translate3d(${offsetLeft +
                targetWidth / 2 -
                offsetWidth / 2}px, 0px, 0px)`;
        }
    }, [offsetLeft, targetWidth]);

    return (
        <div
            className={classNames(prefix, { [`${prefix}-animate`]: recorder > 0 }, props.className)}
            style={props.style}
            ref={inkRef}
        />
    );
};

export default TabInkbar;
